import { BssListenersHandler } from './common/bss-listener-handler';
import { commonFunctions } from './common/common-functions';
export var createInit = function (_a) {
    var BSSConnector = _a.BSSConnector;
    var onUpdateFinance = function (elementValue) {
        var params = elementValue.detail.params;
        if (params && typeof postal !== 'undefined') {
            postal.publish({
                channel: 'com.toyota.tme.t1.finance',
                topic: 'finance.tucl.financeQuoteId.calculated',
                data: params,
            });
            postal.publish({
                channel: 'com.toyota.tme.t1.dialog',
                topic: 'materialBox.close',
                data: { closeAllMaterialBoxes: true },
            });
        }
    };
    return function (options) {
        this.initFunctionType = 'INIT_UC';
        var listenerHandler = new BssListenersHandler(this, options, onUpdateFinance);
        this.initOptions = options.configuration;
        var _a = this.initOptions, environment = _a.Environment, sessionKey = _a.SessionKey;
        this.configData = commonFunctions.prepareData(this, this.initOptions);
        var _b = this.configData || {}, country = _b.country, brand = _b.brand, elementType = _b.elementType;
        this.BSSController = new BSSConnector(environment, this.resolutionsConfig, this.version, this.elementType, sessionKey, options.location, {
            lang: this.language,
            brand: brand,
            country: country,
            elementType: elementType
        }, listenerHandler.getInitBssListenersFunction());
        if (this.options) {
            this.BSSController.setOptions(this.options);
        }
        this.BSSController.setContainer('.bss-entity-container');
        this.BSSController.initFlowWithParams(this.configData);
        this.isInited = true;
    };
};
